"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectUserLanguage = void 0;
var constants_1 = require("utils/constants");
var languages_1 = require("utils/helpers/languages");
var selectUserLanguage = function (state) {
    return state.auth.current.user.foldL(function () { return (0, languages_1.getLanguageByCode)(constants_1.DEFAULT_LANGUAGE); }, function (_a) {
        var language = _a.language;
        return (0, languages_1.getLanguageByCode)(language !== null && language !== void 0 ? language : constants_1.DEFAULT_LANGUAGE);
    });
};
exports.selectUserLanguage = selectUserLanguage;
